<template>
  <drag-dialog
    :append-to-body="true"
    :show.sync="dialog"
    :title="isAdd ? '新增菜单' : '编辑菜单'"
    :enableDrag="true"
    width="500px"
    @close="cancel">
    <dynamic-form
    :formConfig="formConfig"
    v-model="form"
    @submit="doSubmit"
    @cancelForm="cancel"
    ref="pageForm"></dynamic-form>
  </drag-dialog>
</template>

<script>
import { getPermissionTree, add, edit } from '@/api/permission'
import DragDialog from '@/components/DragDialog'
import '@/components/dynamic-form';
export default {
  props: {
    isAdd: {
      type: Boolean,
      required: true
    },
    supThis: {
      type: Object,
    }
  },
  components: {
    DragDialog
  },
  watch: {
    treeData: function(val) {
      this.$nextTick(() => {
          this.$set(this.formConfig.formItemList[3], 'options', val)
      })
    },
    dialog(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.pageForm.$refs.dynamicForm.clearValidate();
        });
      }
    }
  },
  created() {
    this.getPermissions()
  },
  data() {
    return {
      loading: false, dialog: false,
      form: {},
      formConfig: {
        formItemList: [
            {
                label: "菜单类型",
                key: "type",
                type: "radio",
                value: 1,
                disabled: false,
                multiple: false,
                placeholder: "请选择",
                rules: [{
                        required: true,
                        message: "不能为空",
                        trigger: "change"
                    }
                ],
                options: [
                    {
                        value: 0,
                        label: "目录"
                    },
                    {
                        value: 1,
                        label: "菜单"
                    },
                    {
                        value: 2,
                        label: "权限"
                    }
                ]
            },
            {
              type: "text",
              key: "name",
              label: "菜单名称",
              placeholder: "请输入名称",
              rules: [
                  { required: true, message: "不能为空", trigger: "blur" }
              ]
            },
            {
              type: "text",
              key: "perms",
              label: "权限标识",
              placeholder: "请输入标识 module:edit",
              rules: [
                  { required: true, message: "不能为空", trigger: "blur" }
              ]
            },
            {
                label: '上级菜单',
                key: 'parentId',
                type: 'treeSelect',
                multiple: false,
                clearable: true,
                props: {
                    children: 'children',
                    label: 'name',
                    value: 'id'
                },
                options: this.treeData
            },
            {
              type: "text",
              key: "icon",
              label: "菜单图标",
              placeholder: "请输入图标"
            },
            {
              type: "text",
              key: "path",
              label: "链接地址",
              placeholder: "请输入地址"
            },
            {
              type: "text",
              key: "component",
              label: "路由组件",
              placeholder: "请输入组件路径"
            },
            {
                type: "radio",
                label: "是否启用",
                value: true,
                button: false,
                border: false,
                key: "enabled",
                options: [
                    {
                        label: '启用',
                        value: true
                    },
                    {
                        label: '禁用',
                        value: false
                    }
                ]
            }
        ]
      },
      treeData: []
    }
  },
  methods: {
    cancel() {
      this.resetForm()
    },
    doSubmit(val) {
      this.form = val
      if (this.isAdd) {
          this.doAdd()
      } else this.doEdit()
    },
    doAdd() {
      add(this.form).then(res => {
        this.resetForm()
        this.$notify({
          title: '添加成功',
          type: 'success',
          duration: 2500
        })
        this.loading = false
        this.supThis.dataTableInit()
        this.getPermissions()
      }).catch(err => {
        this.loading = false
        console.log(err)
      })
    },
    doEdit() {
      edit(this.form).then(res => {
        this.resetForm()
        this.$notify({
          title: '修改成功',
          type: 'success',
          duration: 2500
        })
        this.loading = false
        this.supThis.dataTableInit()
        this.getPermissions()
      }).catch(err => {
        this.loading = false
        console.log(err.response.data.message)
      })
    },
    resetForm() {
      this.dialog = false
      this.$refs.pageForm.resetForm()
    },
    getPermissions() {
      const permType = '0,1' // 获取目录菜单类型
      getPermissionTree({ type: permType }).then(res => {
        this.treeData =  res.data || []
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>

</style>
